import { NavLink } from 'react-router-dom'
import { ReactComponent as PsLogo} from './playstation-logo.svg'

function CompHeader() {
    const title = "PSN Game List"
    const about = "App made as an exercise to list PSN games for my account. For now it is an offline list that was extracted previously from PSN GraphQL."

    const initBeforeUnLoad = () => {
        window.onbeforeunload = (event) => {
            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = "";
            }
            return "";
        }
    }

    window.onload = function () {
        initBeforeUnLoad();
    };

    return (
        <header>
            <div className="collapse bg-dark" id="navbarHeader">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-8 col-md-7 py-4">
                            <h4 className="text-white">{title}</h4>
                            <p className="text-muted">{about}</p>
                        </div>
                        {/*
                        <div className="col-sm-4 offset-md-1 py-4">
                            <h4 className="text-white">Contact</h4>
                            <ul className="list-unstyled">
                                <li><a className="text-white" href="/">Facebook</a></li>
                                <li><a className="text-white" href="/">Twitter</a></li>
                                <li><a className="text-white" href="/">Instagram</a></li>
                            </ul>
                        </div>
                        */}
                    </div>
                </div>
            </div>
            <nav className="navbar navbar-dark bg-dark shadow-sm">
                <div className="container d-flex justify-content-between">
                    <NavLink className="navbar-brand d-flex align-items-center" to="/">
                        <PsLogo className="home-logo" />
                        {/*<NavLink to="/" className="btn btn-sm btn-outline-secondary">Voltar</NavLink>*/}
                    </NavLink>
                    
                    <button className="navbar-toggler collapsed" data-toggle="collapse" data-target="#navbarHeader">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
        </header>
    )
}

export default CompHeader